import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import JoinVdrButton from './JoinVdrButton';
import { INTRALINKS_VDR_URL } from '../../config';

const OfferVdr = ({ tenant, investorUser, offerId, toggleDataRoom }) => (
  <Fragment>
    {/* {hasJoinedWorkspace ? (
      <Link
        style={{
          textDecoration: 'none',
          width: 'inherit',
          marginRight: '10px',
        }}
        className='btn-small-outline w-button'
        target='_blank'
        to={`${INTRALINKS_VDR_URL}/AZ?w=${workspaceId}&br=1&p=3`}
      >
        <div className='text-block-3'>View Data Room</div>
      </Link>
    ) : ( */}
    <JoinVdrButton
      investorUser={investorUser}
      toggleDataRoom={toggleDataRoom}
      tenant={tenant}
      offerId={offerId}
    />
    {/* )} */}
    <br />
  </Fragment>
);

OfferVdr.propTypes = {
  workspaceId: PropTypes.string.isRequired,
  offerId: PropTypes.string.isRequired,
  hasJoinedWorkspace: PropTypes.bool.isRequired,
};

export default OfferVdr;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferVdr.js